export var HsePolicies;
(function (HsePolicies) {
    HsePolicies["prime_publish_project_with_tag_restriction"] = "prime_publish_project_with_tag_restriction";
    HsePolicies["prime_publish_project_unrestricted"] = "prime_publish_project_unrestricted";
    HsePolicies["limb_publish_project_with_tag_restriction"] = "limb_publish_project_with_tag_restriction";
    HsePolicies["edit_project_with_tag_restriction"] = "edit_project_with_tag_restriction";
    HsePolicies["edit_project_with_tag_expert_restriction"] = "edit_project_with_tag_expert_restriction";
    HsePolicies["view_visual_research_ctx"] = "view_visual_research_ctx";
    HsePolicies["view_opa"] = "view_opa";
    HsePolicies["view_project"] = "view_project";
    HsePolicies["view_draft_project"] = "view_draft_project";
    HsePolicies["view_book"] = "view_book";
    HsePolicies["view_draft_book"] = "view_draft_book";
    HsePolicies["move_to_draft_book"] = "move_to_draft_book";
    HsePolicies["can_supervise_book"] = "can_supervise_book";
    HsePolicies["edit_project"] = "edit_project";
    HsePolicies["edit_project_self"] = "edit_project";
    HsePolicies["edit_draft_project"] = "edit_draft_project";
    HsePolicies["can_supervise_project"] = "can_supervise_project";
    HsePolicies["can_supervise_lms_project"] = "can_supervise_lms_project";
    HsePolicies["can_clear_curators_lst_project"] = "can_clear_curators_lst_project";
    HsePolicies["can_pdf_print_project"] = "can_pdf_print_project";
    HsePolicies["move_edit_project"] = "move_edit_project";
    HsePolicies["allow_send_project_to_competition"] = "allow_send_project_to_competition";
    HsePolicies["create_project"] = "create_project";
    HsePolicies["create_supervisionable_project"] = "create_supervisionable_project";
    HsePolicies["allowed_to_be_team_owner"] = "allowed_to_be_team_owner";
    HsePolicies["allowed_push_project_to_artz"] = "allowed_push_project_to_artz";
    HsePolicies["edit_project_defence"] = "edit_project_defence";
    HsePolicies["edit_defence_book"] = "edit_defence_book";
    HsePolicies["edit_defence_post_longread"] = "edit_defence_post_longread";
    HsePolicies["create_book"] = "create_book";
    HsePolicies["edit_book"] = "edit_book";
    HsePolicies["edit_book_self"] = "edit_book_self";
    HsePolicies["view_author_roles"] = "view_author_roles";
    HsePolicies["edit_author_roles"] = "edit_author_roles";
    HsePolicies["create_unit"] = "create_unit";
    HsePolicies["edit_units_settings"] = "edit_units_settings";
    HsePolicies["edit_unit_shops_settings"] = "edit_unit_shops_settings";
    HsePolicies["edit_owned_unit_settings"] = "edit_owned_unit_settings";
    HsePolicies["edit_unit_owned_shop_settings"] = "edit_unit_owned_shop_settings";
    HsePolicies["create_competitions"] = "create_competitions";
    HsePolicies["moderate_competitions"] = "moderate_competitions";
    HsePolicies["moderate_prime_showcase"] = "moderate_prime_showcase";
    HsePolicies["moderate_limb_showcase"] = "moderate_limb_showcase";
    HsePolicies["access_ui_units_admin"] = "access_ui_units_admin";
    HsePolicies["access_ui_content_admin"] = "access_ui_content_admin";
    HsePolicies["access_brief_competitions"] = "access_brief_competitions";
    HsePolicies["access_competitions"] = "access_competitions";
    HsePolicies["like_value_10"] = "like_value_10";
    HsePolicies["like_value_15"] = "like_value_15";
    HsePolicies["like_value_25"] = "like_value_25";
    HsePolicies["like_value_30"] = "like_value_30";
    HsePolicies["like_value_35"] = "like_value_35";
    HsePolicies["like_value_50"] = "like_value_50";
    HsePolicies["like_value_prefix"] = "like_value_";
})(HsePolicies || (HsePolicies = {}));
//# sourceMappingURL=HsePolicies.js.mapexport var HsePolicies;
(function (HsePolicies) {
    HsePolicies["prime_publish_project_with_tag_restriction"] = "prime_publish_project_with_tag_restriction";
    HsePolicies["prime_publish_project_unrestricted"] = "prime_publish_project_unrestricted";
    HsePolicies["limb_publish_project_with_tag_restriction"] = "limb_publish_project_with_tag_restriction";
    HsePolicies["edit_project_with_tag_restriction"] = "edit_project_with_tag_restriction";
    HsePolicies["edit_project_with_tag_expert_restriction"] = "edit_project_with_tag_expert_restriction";
    HsePolicies["view_visual_research_ctx"] = "view_visual_research_ctx";
    HsePolicies["view_opa"] = "view_opa";
    HsePolicies["view_project"] = "view_project";
    HsePolicies["view_draft_project"] = "view_draft_project";
    HsePolicies["view_book"] = "view_book";
    HsePolicies["view_draft_book"] = "view_draft_book";
    HsePolicies["move_to_draft_book"] = "move_to_draft_book";
    HsePolicies["can_supervise_book"] = "can_supervise_book";
    HsePolicies["edit_project"] = "edit_project";
    HsePolicies["edit_project_self"] = "edit_project";
    HsePolicies["edit_draft_project"] = "edit_draft_project";
    HsePolicies["can_supervise_project"] = "can_supervise_project";
    HsePolicies["can_supervise_lms_project"] = "can_supervise_lms_project";
    HsePolicies["can_clear_curators_lst_project"] = "can_clear_curators_lst_project";
    HsePolicies["can_pdf_print_project"] = "can_pdf_print_project";
    HsePolicies["move_edit_project"] = "move_edit_project";
    HsePolicies["allow_send_project_to_competition"] = "allow_send_project_to_competition";
    HsePolicies["create_project"] = "create_project";
    HsePolicies["create_supervisionable_project"] = "create_supervisionable_project";
    HsePolicies["allowed_to_be_team_owner"] = "allowed_to_be_team_owner";
    HsePolicies["allowed_push_project_to_artz"] = "allowed_push_project_to_artz";
    HsePolicies["edit_project_defence"] = "edit_project_defence";
    HsePolicies["edit_defence_book"] = "edit_defence_book";
    HsePolicies["edit_defence_post_longread"] = "edit_defence_post_longread";
    HsePolicies["create_book"] = "create_book";
    HsePolicies["edit_book"] = "edit_book";
    HsePolicies["edit_book_self"] = "edit_book_self";
    HsePolicies["view_author_roles"] = "view_author_roles";
    HsePolicies["edit_author_roles"] = "edit_author_roles";
    HsePolicies["create_unit"] = "create_unit";
    HsePolicies["edit_units_settings"] = "edit_units_settings";
    HsePolicies["edit_unit_shops_settings"] = "edit_unit_shops_settings";
    HsePolicies["edit_owned_unit_settings"] = "edit_owned_unit_settings";
    HsePolicies["edit_unit_owned_shop_settings"] = "edit_unit_owned_shop_settings";
    HsePolicies["create_competitions"] = "create_competitions";
    HsePolicies["moderate_competitions"] = "moderate_competitions";
    HsePolicies["moderate_prime_showcase"] = "moderate_prime_showcase";
    HsePolicies["moderate_limb_showcase"] = "moderate_limb_showcase";
    HsePolicies["access_ui_units_admin"] = "access_ui_units_admin";
    HsePolicies["access_ui_content_admin"] = "access_ui_content_admin";
    HsePolicies["access_brief_competitions"] = "access_brief_competitions";
    HsePolicies["access_competitions"] = "access_competitions";
    HsePolicies["like_value_10"] = "like_value_10";
    HsePolicies["like_value_15"] = "like_value_15";
    HsePolicies["like_value_25"] = "like_value_25";
    HsePolicies["like_value_30"] = "like_value_30";
    HsePolicies["like_value_35"] = "like_value_35";
    HsePolicies["like_value_50"] = "like_value_50";
    HsePolicies["like_value_prefix"] = "like_value_";
})(HsePolicies || (HsePolicies = {}));
//# sourceMappingURL=HsePolicies.js.map